import React, { useState } from 'react';
import { api } from '../api';

const QUICK = ['Tea / Snacks', 'Ice', 'Transport', 'Cleaning', 'Water can', 'Other'];

export default function AddExpenseButton() {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState('');
  const [desc, setDesc] = useState('');
  const [mode, setMode] = useState('cash');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const close = () => { setOpen(false); setAmount(''); setDesc(''); setMode('cash'); setErr(''); };
  const save = async () => {
    setErr('');
    if (!(Number(amount) >= 1)) return setErr('Enter the amount');
    if (desc.trim().length < 2) return setErr('Write what it is for');
    setBusy(true);
    try {
      await api.post('/shifts/expense', { amount: Number(amount), description: desc.trim(), payment_mode: mode });
      close();
      window.location.reload();
    } catch (e) { setErr(e.message || 'Could not save'); }
    setBusy(false);
  };

  const inp = { width: '100%', height: 46, padding: '0 12px', border: '1px solid #e2dcea', borderRadius: 12, font: 'inherit', fontSize: 16, boxSizing: 'border-box' };
  const chip = (on) => ({ padding: '7px 12px', borderRadius: 999, border: `1px solid ${on ? '#6948dc' : '#e2dcea'}`, background: on ? '#f1edff' : '#fff', color: on ? '#5b3fd9' : '#3a3150', cursor: 'pointer', font: 'inherit', fontSize: 13, fontWeight: 600 });

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 0 10px' }}>
        <button type="button" onClick={() => setOpen(true)}
          style={{ padding: '10px 16px', borderRadius: 12, border: '1px solid #f4d7a8', background: '#fff7ea', color: '#8a4b00', fontWeight: 700, cursor: 'pointer', font: 'inherit' }}>
          ＋ Add expense
        </button>
      </div>
      {open && (
        <div onMouseDown={close} style={{ position: 'fixed', inset: 0, background: 'rgba(20,14,38,.45)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onMouseDown={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 18, width: 'min(440px, 100%)', padding: 20, boxShadow: '0 24px 70px rgba(0,0,0,.25)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <strong style={{ fontSize: 18 }}>Add shop expense</strong>
              <button type="button" onClick={close} style={{ border: 0, background: '#f3f4f6', borderRadius: 8, width: 32, height: 32, cursor: 'pointer' }}>✕</button>
            </div>
            <label style={{ fontSize: 13, fontWeight: 700, color: '#6b6280' }}>Amount (₹)</label>
            <input autoFocus type="number" inputMode="decimal" min="1" value={amount} onChange={(e) => setAmount(e.target.value)}
              onWheel={(e) => e.currentTarget.blur()} style={{ ...inp, margin: '6px 0 14px', fontSize: 22, fontWeight: 800 }} />
            <label style={{ fontSize: 13, fontWeight: 700, color: '#6b6280' }}>For</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, margin: '6px 0 8px' }}>
              {QUICK.map((q) => <button type="button" key={q} style={chip(desc === q)} onClick={() => setDesc(q === 'Other' ? '' : q)}>{q}</button>)}
            </div>
            <input value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="e.g. Ice block 2 nos" style={{ ...inp, marginBottom: 14 }} />
            <label style={{ fontSize: 13, fontWeight: 700, color: '#6b6280' }}>Paid by</label>
            <div style={{ display: 'flex', gap: 8, margin: '6px 0 14px' }}>
              <button type="button" style={chip(mode === 'cash')} onClick={() => setMode('cash')}>💵 Cash from drawer</button>
              <button type="button" style={chip(mode === 'upi')} onClick={() => setMode('upi')}>📱 UPI</button>
            </div>
            {err && <div style={{ color: '#d63d5b', fontWeight: 700, marginBottom: 10 }}>{err}</div>}
            <button type="button" onClick={save} disabled={busy}
              style={{ width: '100%', height: 48, border: 0, borderRadius: 12, background: '#6948dc', color: '#fff', fontWeight: 800, fontSize: 16, cursor: 'pointer', font: 'inherit' }}>
              {busy ? 'Saving…' : 'Save expense'}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
